import { BrowserRouter, Routes, Route } from "react-router-dom";
import "./App.css";
import "./style/general.css";
import PurchasePage from "./components/PurchasePage.tsx";
import NotFoundPage from "./components/NotFoundPage.tsx";
import ErrorPage from "./components/ErrorPage.tsx";
import CompletePage from "./components/CompletePage.tsx";
import TopBar from "./components/Servings/TopBar.tsx";
import Footer from "./components/Servings/Footer.tsx";

export default function App() {
  return (
    <div className="EntirePageContainer">
      <TopBar />
      <div className="ContentContainer">
        <BrowserRouter>
          <Routes>
            <Route path="/purchase/*" element={<PurchasePage />} />
            <Route path="/complete/*" element={<CompletePage />} />
            <Route path="/errorpage" element={<ErrorPage />} />
            <Route path="*" element={<NotFoundPage />} />
          </Routes>
        </BrowserRouter>
      </div>
      <Footer />
    </div>
  );
}
